import { render, staticRenderFns } from "./Lgx264047748465033216.vue?vue&type=template&id=08055e08&scoped=true&"
import script from "./Lgx264047748465033216.vue?vue&type=script&lang=js&"
export * from "./Lgx264047748465033216.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08055e08",
  null
  
)

export default component.exports